import styled from 'styled-components';
import { pluralize } from 'common/utils/utils';
import { SPACES, LINE_HEIGHT } from 'common/constants/sizes';
import { Flex, Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import Bullet from 'components/base/Bullet';
import StyledAvatar from 'components/StyledAvatar';
import InfoBox from 'components/InfoBox';
import { bulletParams } from 'views/root/views/home/views/settings/views/ContributorsAndTeams/Contributor/services/contributor.service';
import { LBButton } from '@linearb/buzz';

const RemoveWrapper = styled(Flex)`
  position: relative;
  right: 1rem;
  z-index: 1;
  svg {
    background-color: white;
    border-radius: 50%;
  }
`;

const RemoveFromTeamModal = ({
  id,
  name = '',
  teams = [],
  teamsNames,
  isSyncedContributor,
  avatar_url,
  onCancel,
  onSubmit
}) => {
  const firstName = name.split(' ')[0];

  return (
    <Flex direction='column' padding='medium'>
      <Flex direction='row' items='center' pb='normal'>
        <Flex items='flex-end'>
          <StyledAvatar avatar={{ url: avatar_url, isGrayedOut: true }} />
          <RemoveWrapper>
            <Icon name='errorOutline' color='torchRed' size='small'></Icon>
          </RemoveWrapper>
        </Flex>
        <Text size='x-large' pl={SPACES.small} multiLineEllipsisAfter={2}>
          {isSyncedContributor ? `Unable to remove ${name}` : `Remove ${name}?`}
        </Text>
      </Flex>
      {isSyncedContributor ? (
        <Padding b='medium'>
          <Text size='medium' lineHeight={LINE_HEIGHT.medium}>
            {name} is a member of a GitHub synchronized team.
            <br />
            If you wish to remove them from billing, manage team membership in
            GitHub.
          </Text>
        </Padding>
      ) : (
        <>
          <Bullet {...bulletParams} mt='1rem'>
            <Text size='medium' weight='700' lineHeight={LINE_HEIGHT.medium}>
              {firstName} will be removed from {pluralize(teams.length, 'team')}
            </Text>
          </Bullet>
          <Bullet {...bulletParams} mt='1rem'>
            <Text size='medium' lineHeight={LINE_HEIGHT.medium}>
              <b>Activity will not be tracked for {firstName}</b> and you will
              not see it on any analysis or metrics.
            </Text>
          </Bullet>
          <Bullet {...bulletParams} mt='1rem'>
            <Text size='medium' lineHeight={LINE_HEIGHT.medium}>
              Contact your CSM to understand your license and billing impact
            </Text>
          </Bullet>
          <InfoBox mb='x-medium' iconAlign='center' iconSize='normal'>
            <Text size='medium' lineHeight={LINE_HEIGHT.medium}>
              You can always add people back to teams by clicking "Edit team" on
              the Teams screen
            </Text>
          </InfoBox>
        </>
      )}

      {isSyncedContributor ? (
        <Flex direction='row-reverse'>
          <LBButton onClick={onCancel}>Close</LBButton>
        </Flex>
      ) : (
        <Flex direction='row-reverse'>
          <Padding l='small'>
            <LBButton
              onClick={() => {
                onSubmit({
                  id,
                  teamsNames,
                  contributorName: name
                });
              }}
            >
              Remove
            </LBButton>
          </Padding>
          <LBButton variant='outline' onClick={onCancel}>
            Don't remove
          </LBButton>
        </Flex>
      )}
    </Flex>
  );
};

export default RemoveFromTeamModal;
